export default "__VITE_ASSET__R8g0NHay__";